import { useState, useEffect, createContext, useContext } from 'react';

import Utils from '../../utils/utils.js';
import { getRoleAssignedToUser } from '../../components/user/permissions/rolesMapping.js';
import { usePermissionsInDomain } from '../Hooks.jsx';

const RolesContext = createContext([]);

export const RolesProvider = ({
    deploymentId,
    children,
}) => {
    const [roles, setRoles] = useState([]);

    const allPermissions = usePermissionsInDomain({ domainId: Utils.getDomain() });

    useEffect(() => {
        const me = JSON.parse(window.sessionStorage.getItem('user')) || {};

        if (me) {
            if (me.appAdmin) {
                setRoles(['app-admin']);
            }
            else {
                if (!allPermissions || allPermissions.length === 0) {
                    return;
                }
                const userPermissions = me.uiPermissions?.map(({ _id }) => allPermissions.find((permission) => permission._id === _id)).filter((permission) => !!permission);

                const role = getRoleAssignedToUser({
                    userPermissions,
                    allPermissions,
                    selectedDomain: Utils.getDomain(),
                    deploymentId
                });

                if (role) {
                    setRoles([role._id]);
                }
            }
        }
    }, [allPermissions, deploymentId]);

    return (
        <RolesContext.Provider value={roles}>
            {children}
        </RolesContext.Provider>
    );
};

export const useRoles = () => useContext(RolesContext);